import Card from "@/shared/data-display/card";
import { ReactNode } from "react";
import { useTranslations } from "use-intl";
import Text from "@/shared/typography/text";
import { DynamicAttributeEntityTitle } from "@/modules/dynamic-attributes/shared/ui/dynamic-attribute-entity-title";
import { DynamicAttributeEntity } from "gql/graphql";

export function EditorHead({
  entityName,
  groupSelector,
  options,
}: {
  entityName: DynamicAttributeEntity;
  groupSelector?: ReactNode;
  options?: ReactNode;
}) {
  const t = useTranslations("AttributesPageWidget");

  return (
    <Card>
      <div className="flex justify-between items-center mb-5">
        <Text type="headline1">
          <DynamicAttributeEntityTitle entity={entityName} />
        </Text>
        <div className="flex space-x-4">{options}</div>
      </div>
      <div className="grid gap-2 mb-3">
        <Text type="subtitle2">{t("Attribute Group")}</Text>
        {groupSelector}
      </div>
    </Card>
  );
}
